import {
  DeclarationUpdatePayload,
  ManualMovementPayload,
  OpenCashSessionPayload,
} from '@/@types/cash-management';
import {
  cancelManualMovement,
  closeCashSession,
  createManualMovement,
  openCashSession,
  revertCashSessionStatus,
  startReconciliation,
  updateDeclarations,
} from '@/api/cash_management';
import { useMutation } from '@tanstack/react-query';
import { invalidateCashSessionQueries } from '../utils';

export function useCashSession() {
  const openCashSessionMutation = useMutation({
    mutationFn: (payload: OpenCashSessionPayload) => openCashSession(payload),
    onSuccess: (data) => invalidateCashSessionQueries(data.id),
  });

  const createManualMovementMutation = useMutation({
    mutationFn: (payload: ManualMovementPayload) =>
      createManualMovement(payload),
    onSuccess: (data) => invalidateCashSessionQueries(data.cashSessionId),
  });

  const cancelManualMovementMutation = useMutation({
    mutationFn: (id: string) => cancelManualMovement(id),
    onSuccess: (data) => invalidateCashSessionQueries(data.id),
  });

  const startReconciliationMutation = useMutation({
    mutationFn: (id: string) => startReconciliation(id),
    onSuccess: (data) => invalidateCashSessionQueries(data.id),
  });

  const updateDeclarationsMutation = useMutation({
    mutationFn: ({
      id,
      payload,
    }: {
      id: string;
      payload: DeclarationUpdatePayload;
    }) => updateDeclarations(id, payload),
    onSuccess: (data) => invalidateCashSessionQueries(data.id),
  });

  const closeCashSessionMutation = useMutation({
    mutationFn: (id: string) => closeCashSession(id),
    onSuccess: (data) => invalidateCashSessionQueries(data.id),
  });

  const revertCashSessionStatusMutation = useMutation({
    mutationFn: (id: string) => revertCashSessionStatus(id),
    onSuccess: (data) => invalidateCashSessionQueries(data.id),
  });

  return {
    openCashSessionMutation,
    createManualMovementMutation,
    cancelManualMovementMutation,
    startReconciliationMutation,
    updateDeclarationsMutation,
    closeCashSessionMutation,
    revertCashSessionStatusMutation,
  };
}
